<template>
    <div class="stat-grid">
        <div v-for="(item, index) in items" :key="index" class="stat-item" :class="{ 'half-width': halfWidth }">
            <!-- Grouped items with vertical separator -->
            <template v-if="item.grouped">
                <div class="stat-grouped">
                    <div v-for="(subItem, subIndex) in item.items" :key="subIndex" class="stat-group-item">
                        <div class="stat-label">{{ subItem.label }}</div>
                        <div class="stat-value-row">
                            <span class="stat-value">{{ formatValue(subItem.value, subItem.format) }}</span>
                            <div
                                v-if="subItem.variation !== undefined && subItem.variation !== 0"
                                class="stat-variation"
                                :class="variationClass(subItem.variation)"
                            >
                                {{ formatVariation(subItem.variation) }}
                            </div>
                        </div>
                        <div v-if="subItem.subtitle" class="stat-subtitle">{{ subItem.subtitle }}</div>
                    </div>
                </div>
            </template>
            <!-- Single item -->
            <template v-else>
                <div class="stat-label">{{ item.label }}</div>
                <div class="stat-value-row">
                    <span class="stat-value poppinsExtraBold" :style="{ fontSize: normalizeFontSize(19) }">{{
                        formatValue(item.value, item.format)
                    }}</span>
                    <div
                        v-if="item.variation !== undefined && item.variation !== 0"
                        class="stat-variation"
                        :class="variationClass(item.variation)"
                    >
                        {{ formatVariation(item.variation) }}
                    </div>
                </div>
                <div v-if="item.subtitle" class="stat-subtitle">{{ item.subtitle }}</div>
            </template>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeFontSize from '../../../../utils/normalizeFontSize'

export default {
    name: 'StatGrid',
    props: {
        items: {
            type: Array,
            required: true,
            // Expected format: [{ label: 'Label', value: 59, format: 'percent', variation: 12, subtitle: 'Vs semaine dernière' }]
        },
        columns: {
            type: Number,
            default: 2,
        },
        halfWidth: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        formatValue(value, format) {
            switch (format) {
                case 'percent':
                    return `${value}%`
                case 'currency':
                    return `${value.toLocaleString(this.$currencyLocale?.replace('_', '-') || 'fr-FR')}${this.$symbolCurrency}`
                default:
                    return value.toLocaleString(this.$currencyLocale?.replace('_', '-') || 'fr-FR')
            }
        },
        variationClass(variation) {
            return variation >= 0 ? 'positive' : 'negative'
        },
        formatVariation(variation) {
            const sign = variation >= 0 ? '+' : ''
            return `${sign}${variation}%`
        },
    },
}
</script>

<style scoped>
.stat-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.stat-item {
    flex: 1 1 100%;
    min-width: 100%;
    padding: 15px 18px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.3);
}
@media (max-width: 768px) {
    .stat-item {
        padding: 8px 10px;
    }
    .stat-group-item {
        margin-right: 10px;
    }
}

.stat-item.half-width {
    flex: 1 1 calc(50% - 5px);
    max-width: calc(50% - 5px);
}

.stat-label {
    color: #fff;
    font-family: Poppins, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stat-value-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 4px;
}

.stat-value {
    color: #fff;
    line-height: 140%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stat-variation {
    padding: 2px 6px;
    border-radius: 8px;
    font-family: Poppins, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
}

.stat-variation.positive {
    background: #00452c;
    color: #00d589;
}

.stat-variation.negative {
    background: #37242f;
    color: #c52b21;
}

.stat-subtitle {
    color: #a0aec0;
    font-family: Poppins, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
    margin-top: 2px;
}

.stat-grouped {
    display: flex;
    gap: 0;
    width: 100%;
    overflow: hidden;
}

.stat-group-item {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.stat-group-item:not(:last-child) {
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    margin-right: 15px;
}

.stat-group-item:last-child {
    padding-right: 0;
}

.stat-value-row {
    flex-wrap: nowrap;
    overflow: hidden;
}

@media (max-width: 768px) {
    .stat-item {
        flex: 1 1 100%;
        min-width: 100%;
    }

    .stat-group-item {
        margin-right: 10px;
    }

    .stat-label {
        font-size: 11px;
    }

    .stat-value {
        font-size: 16px;
    }
}
</style>
